import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import fields from '../../../lib/fields';
import FormFieldsCompact from '../../form/fieldsCompact';

export const LESSON_FIELDS = [
    'sortOrder',
    'title',
    'estimatedMinutes',
    'body',
    'youtube',
    'images',
    'files',
    'quiz',
    'quizRequired',
];

/**
 * Lesson editor drawer (editElearningLesson / newElearningLesson).
 * New: fills newElearningLesson and creates via adminCreate, then switches to
 * the auto-saving editor for that lesson. Existing: FormFieldsCompact auto-saves
 * every field through the store (saveField / editArrayObject against /admin/).
 */
@observer
class AdminElearningLessonEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('elearningLesson'),
            creating: false,
        };
    }

    componentDidMount() {
        const { elearningLessonStore } = this.props.stores;
        const { isNew, courseId } = this.props;
        if (isNew) {
            elearningLessonStore.updateKeyValue('newElearningLesson', { course: courseId, quizRequired: 1 });
        }
    }

    create = async () => {
        const { elearningLessonStore, appState } = this.props.stores;
        const { courseId, drawerLevel } = this.props;
        const { newElearningLesson } = elearningLessonStore;
        this.setState({ creating: true });
        const response = await elearningLessonStore.adminCreate({ ...newElearningLesson, course: courseId });
        this.setState({ creating: false });
        const created = response?.data?.elearningLesson;
        if (created?.id) {
            await elearningLessonStore.loadForCourse(courseId);
            elearningLessonStore.setCurrent(created);
            appState.addToast({ type: 'success', message: 'Leksjon opprettet' }, 3000);
            appState.closeDrawer(false, drawerLevel);
            appState.openDrawer('editElearningLesson', { courseId, lessonId: created.id, height: appState.drawerHeightMediumLarge }, drawerLevel);
        } else {
            appState.addToast({ type: 'error', message: response?.message || 'Kunne ikke opprette leksjon' }, 5000);
        }
    }

    done = async () => {
        const { elearningLessonStore, appState } = this.props.stores;
        const { courseId, drawerLevel } = this.props;
        await elearningLessonStore.loadForCourse(courseId);
        appState.closeDrawer(false, drawerLevel);
    }

    render() {
        const { stores, isNew, drawerLevel } = this.props;
        const { elearningLessonStore } = stores;
        const { sections, creating } = this.state;
        const lesson = elearningLessonStore.elearningLesson || {};

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='elearning.newLesson'>New lesson</Text> : <span><Text id='elearning.editLesson'>Edit lesson</Text>: {lesson.title}</span>}
                    </div>
                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <FormFieldsCompact
                            stores={stores}
                            sections={sections}
                            fields={LESSON_FIELDS}
                            holdingStore={elearningLessonStore}
                            objectName={isNew ? 'newElearningLesson' : 'elearningLesson'}
                            isNew={!!isNew}
                            isAdmin={true}
                            drawerLevel={drawerLevel}
                        />
                    </div>
                    <div class='px-3 pt-3 d-flex gap-2 align-items-center'>
                        {isNew ? (
                            <button type='button' class='btn btn-primary rounded-pill px-4' onClick={this.create} disabled={creating}>
                                {creating && <i class='fa-solid fa-spinner fa-spin me-1' />}
                                <Text id='elearning.createLesson'>Create lesson</Text>
                            </button>
                        ) : (
                            <>
                                <button type='button' class='btn btn-primary rounded-pill px-4' onClick={this.done}>
                                    <Text id='elearning.doneEditing'>Done</Text>
                                </button>
                                <small class='text-body-secondary'><Text id='elearning.autoSaved'>Changes are saved automatically.</Text></small>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default AdminElearningLessonEdit;
